module.exports = __webpack_public_path__ + "media/images/restaurant/areas/tokyo_m-041d3e7739d2dd599226641d383a4b96.png";